// Shared pill base + amber "awaiting" pair = attention: these PO lines haven't
// reached Shopify (push failed, or skipped while sync was off) and need a
// Retry Sync. Same look in the PO list and the expanded line rows.
export function NotSyncedPill({ title }: { title: string }) {
  return (
    <span
      className="inline-block rounded-full text-[10.5px] font-semibold px-2 py-0.5 leading-none whitespace-nowrap bg-[var(--status-awaiting-bg)] text-[var(--status-awaiting-fg)]"
      title={title}
      data-testid="not-synced-pill"
    >
      Not synced
    </span>
  )
}
